import { useEffect } from "react";

/**
 * Set the browser tab title (and optionally the meta description) for a route.
 * Titles always start with "Anubandh.ai" per brand.
 *
 * Note: Social crawlers (FB/Twitter/WhatsApp/LinkedIn) read the static index.html
 * tags — this hook improves in-app browser UX and JS-capable SEO crawlers only.
 */
export function usePageMeta(title, description) {
  useEffect(() => {
    const full = title ? `Anubandh.ai — ${title}` : "Anubandh.ai — India's Marriage Intelligence Platform";
    document.title = full;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}
